module.exports = __webpack_public_path__ + "img/wzls.3d3aa1c4.jpg";